module.exports = __webpack_public_path__ + "static/media/Ki.2a5ff834.ttf";